import { createBrowserHistory } from 'history';

class AppHistory {
  constructor(history) {
    this.history = history || createBrowserHistory();
  }

  push = (router) => {
    this.history && this.history.push(router);
  };

  getAppHistory = () => this.history;
}

export default new AppHistory();
